import React, { useEffect, useState, useCallback } from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import {
  TextField,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  CircularProgress,
} from '@material-ui/core';

import { useStyles, Form } from './styles';
import { IVippRequest, useVipp } from '../../hooks/vipp';

import { Button } from '../../../../components/Button';

interface IProps {
  open: boolean;
  onClose: () => void;
}

export const Vipp: React.FC<IProps> = (props) => {
  const classes = useStyles();
  const { loadVipp, saveVipp } = useVipp();
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingVipp, setLoadingVipp] = useState(true);
  const [data, setData] = useState<IVippRequest>({
    userViPP: '',
    passwordViPP: '',
    idPerfil: '',
    codigoPac: '',
    codigoSedex: '',
  });

  useEffect(() => {
    async function loadIntegration(): Promise<void> {
      try {
        const response = await loadVipp();

        if (!response) return;

        setData({
          ...response,
        });
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingVipp(false);
      }
    }
    if (props.open) loadIntegration();
  }, [loadVipp, props.open]);

  const validationSchema = yup.object().shape({
    userViPP: yup.string(),
    passwordViPP: yup.string(),
    idPerfil: yup.string(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...data,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoadingButton(true);

      try {
        await saveVipp(values);
        props.onClose();
      } catch (error) {
        console.log(error);
      }

      setLoadingButton(false);
    },
  });

  const handleClose = useCallback(() => {
    props.onClose();
    formik.resetForm();
    setLoadingVipp(true);
  }, [props, formik]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">VIPP</DialogTitle>
      <DialogContent>
        <Form
          onSubmit={formik.handleSubmit}
          noValidate
          className={classes.form}
        >
          <Grid container spacing={3}>
            {loadingVipp ? (
              <Grid item xs={12}>
                <Typography component="div" align="center">
                  <CircularProgress />
                </Typography>
              </Grid>
            ) : (
              <>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    size="small"
                    required
                    fullWidth
                    label="Usuário Vip"
                    id="userViPP"
                    name="userViPP"
                    value={formik.values.userViPP}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.userViPP && Boolean(formik.errors.userViPP)
                    }
                    helperText={
                      formik.touched.userViPP && formik.errors.userViPP
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    size="small"
                    required
                    fullWidth
                    label="Senha Vip"
                    id="passwordViPP"
                    name="passwordViPP"
                    value={formik.values.passwordViPP}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.passwordViPP &&
                      Boolean(formik.errors.passwordViPP)
                    }
                    helperText={
                      formik.touched.passwordViPP && formik.errors.passwordViPP
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    size="small"
                    required
                    fullWidth
                    label="ID do perfil"
                    id="idPerfil"
                    name="idPerfil"
                    value={formik.values.idPerfil}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.idPerfil && Boolean(formik.errors.idPerfil)
                    }
                    helperText={
                      formik.touched.idPerfil && formik.errors.idPerfil
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    size="small"
                    required
                    fullWidth
                    label="Código Sedex"
                    id="codigoSedex"
                    name="codigoSedex"
                    value={formik.values.codigoSedex}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.codigoSedex &&
                      Boolean(formik.errors.codigoSedex)
                    }
                    helperText={
                      formik.touched.codigoSedex && formik.errors.codigoSedex
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    size="small"
                    required
                    fullWidth
                    label="Código PAC"
                    id="codigoPac"
                    name="codigoPac"
                    value={formik.values.codigoPac}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.codigoPac &&
                      Boolean(formik.errors.codigoPac)
                    }
                    helperText={
                      formik.touched.codigoPac && formik.errors.codigoPac
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Form>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Fechar
        </Button>

        <Button
          onClick={() => formik.handleSubmit()}
          color="secondary"
          variant="contained"
          loading={loadingButton}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
